<div class="main-container">
  <sidebar></sidebar>
  <div class="others p-3">
    <div class="header d-flex align-items-center">
      <div class="m-3 text-white">
        {{pageTitle}}
      </div>
    </div>
    <div class="main">
      <!-- <app-symbol-search></app-symbol-search> -->
      <router-outlet></router-outlet>
    </div>
    <div class="footer d-flex align-items-center justify-content-end font-12 p-2">
      V1.0.0
    </div>
  </div>
</div>